import React, { useEffect, useRef, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import SidebarWOdetails from "./sidebarWOdetails";
import toast from "react-hot-toast";
import { useWorkRequestApi } from "../../../store/api/hooks/workRequestApiHook";
import { useWorkOrderApi } from "../../../store/api/hooks/workOrderApiHook";
import moment from "moment";
import Icon from "../../../components/icons";
import Loader from "../../../components/loader";
import SelectBox from "../../../components/elements/form/selectBox";
import CreateAssetsModal from "../../WorkRequest/_components/createAssets.modal";
import CreateSparePartsModal from "./createSpeareParts.modal";
import { useChecklistApi } from "../../../store/api/hooks/checklistApiHook";
import { deleteAsset } from "../../../store/sagas/assetsSaga";
import { Controller, set, useFieldArray, useForm } from "react-hook-form";
import { useFacilitiesApi } from "../../../store/api/hooks/facilitiesApiHook";
import { useCycleCountApi } from "../../../store/api/hooks/cycleCountApiHook";
import Input from "../../../components/elements/form/input";
import { useUserSelector } from "../../../store/selectors/userSelector";
import CreateStocksModal from "./createStocks.modal";
import { s } from "@fullcalendar/core/internal-common";
import AssetStatus from "../../Assets/_components/assetStatus";
import PartlistWOdetails from "./partslistWOdetails";
import { useAppLoader } from "../../../_common/pageLoader/appLoaderHook";
import { getPermissionInfo } from "../../../_common/functions";

interface Props {
  workorder: any;
  onUpdateRequest?: () => void;
}
interface SparePart {
  requiredQty: any;
  pickedQty: any;
  assetID: any;
  facilityID: any;
  subfacility: any;
  submitAction: any;
}
type sparePartType = {
  id?: any;
  facilityID?: any;
  facilityName?: any;
  subFacilityOptions?: any[];
  subFacilityID?: any;
  subFacilityName?: any;
  workOrderID?: any;
  partsCode?: any;
  partsID?: any;
  pricePerUnit?: any;
  requiredQty?: any;
  sparePartsName?: any;

  pickedQty?: any;
  assetID?: any;
  assetCode?: any;
  assetName?: any;
  isPicked?: any;
  unitID?: any;

  currentStock?: any;
  woSparePartMappingID?: any;
};

interface FormValues {
  sparePartsArr: sparePartType[];
  spareParts: SparePart[];
  submitAction: "savePart" | "FinishPicked";
}

const GeneralWOdetails: React.FC<Props> = ({ workorder, onUpdateRequest = () => { } }) => {
  const params: any = useParams();
  const loggedinuser: any = useUserSelector();
  const location = useLocation();

  const workOrderAPI: any = useWorkOrderApi();
  const checklistAPI: any = useChecklistApi();
  const workRequestAPI: any = useWorkRequestApi();
  const facilityApi: any = useFacilitiesApi();
  const createAssetModalRef: any = useRef();
  const createStockModalRef: any = useRef();
  const createSparePartsModalRef: any = useRef();
  const [showcustomloader, setShowcustomloader] = useState<boolean>(true);
  const [assets, setAssets] = useState<any[]>([]);
  const [facilityoption, setFacilityoption] = useState<any>([]);
  const [wonote, setWonote] = useState<any>(null);
  const [woimages, setWoimages] = useState<any>(null);
  const [wrimages, setWrimages] = useState<any>(null);
  const [wonotetxt, setWonotetxt] = useState<any>(null);
  const [wonotesubmitted, setWonotesubmitted] = useState<boolean>(false);
  const [subfacilitylist, setsubfacilityoption] = useState<any>([]);
  const [selectedAssets, setSelectedAssets] = useState<any>([]);
  const [CheckList, setCheckList] = useState<any[]>([]);
  const [sparePartsData, setSparePartsData] = useState<any[]>([]);
  const [subfacilityOptions, setSubfacilityOptions] = useState<any[][]>([]);
  const [isPickedTrue, setIsPickedTrue] = useState(false);
  const [updateChange, setUpdateChange] = useState(false);
  const [spareParts, setSpareParts] = useState<any>([]);
  const [currentPartsItems, setCurrentPartsItems] = useState<any[]>([]);
  const user: any = useUserSelector();
  const cycleCountAPI = useCycleCountApi();
  const { showLoader, hideLoader } = useAppLoader();
  const assetList = Array.isArray(workorder?.workOrderAssetMappingList)
    ? workorder.workOrderAssetMappingList
    : [];

  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    watch,
    reset,
    getValues,
  } = useForm<FormValues>({
    defaultValues: {
      spareParts: sparePartsData,
    },
  });

  const {
    fields: sparePartsArrFields,
    append,
    update,
    prepend,
    remove,
    swap,
    move,
    insert,
  } = useFieldArray({
    control, // control props comes from useForm (optional: if you are using FormContext)
    name: "sparePartsArr", // unique name for your Field Array
  });
  const submitAction = watch("submitAction");
  const get_note_list_api_call = async (args: any = {}) => {
    return new Promise((resolve, reject) => {
      workOrderAPI.GetWorkOrderNotesList(
        { workOrderID: workorder.workOrderID },
        (resp: any) => {
          resolve(resp);
        },
        (error: any) => {
          toast.error(error);
          reject(error);
        }
      );
    });
  };

  const generalDetails = async () => {
    setShowcustomloader(true);
    const PromiseArr = [];
    PromiseArr.push(get_note_list_api_call());
    PromiseArr.push(
      new Promise((resolve, reject) => {
        workOrderAPI.GetWorkOrderImages(
          { workOrderID: workorder.workOrderID },
          (resp: any) => {
            resolve(resp);
          },
          (error: any) => {
            toast.error(error);
            reject(error);
          }
        );
      })
    );
    if (workorder.workRequestID && +workorder.workRequestID > 0) {
      PromiseArr.push(
        new Promise((resolve, reject) => {
          workRequestAPI.GetWorkRequestImages(
            { WorkRequestID: workorder.workRequestID },
            (resp: any) => {
              resolve(resp);
            },
            (error: any) => {
              reject(error);
            }
          );
        })
      );
    }
    const apiresp: any = await Promise.all(PromiseArr).catch((err: any) => { });
    if (apiresp && Array.isArray(apiresp) && apiresp.length > 0) {
      // Handle the first response for "NOTES"
      if (
        apiresp[0].workOrderNotesList &&
        Array.isArray(apiresp[0].workOrderNotesList)
      ) {
        apiresp[0].workOrderNotesList = apiresp[0].workOrderNotesList.map(
          (o: any) => {
            const bind_addedDate = moment
              .utc(o.addedDate)
              .local()
              .format("MM/DD/YY hh:mm A");
            return {
              ...o,
              bind_addedDate: bind_addedDate,
            };
          }
        );
        setWonote(apiresp[0].workOrderNotesList);
      }

      // Handle the second response for "IMAGES"
      if (apiresp[1]) {
        setWoimages(apiresp[1]);
      }

      if (apiresp[2]) {
        setWrimages(apiresp[2]);
      }
    }
    setShowcustomloader(false);

    console.log("Genetal tab api response ===> ", apiresp);
  };

  const deleteWONote = async (workOrderNoteID: number) => {
    if (!workOrderNoteID || workOrderNoteID <= 0) {
      toast.error(`Invalid note ID`);
      return;
    }
    if (window.confirm(`Are you sure you want to delete this note?`)) {
      const noteresp: any = await new Promise((resolve, reject) => {
        workOrderAPI.DeleteWorkOrderNotes(
          { WorkOrderNotesID: workOrderNoteID },
          (resp: any) => {
            toast.success(`Note deleted successfully`);
            resolve(resp);
          },
          (error: any) => {
            toast.error(error);
            reject(error);
          }
        );
      }).catch((err: any) => {
        console.log(`Error in deleting note`, err);
      });
      if (noteresp.code == 200 && noteresp.successful === true) {
        const noteresp: any = await get_note_list_api_call().catch(
          (err: any) => {
            console.log(`Error in fetching notes after deleting note`, err);
          }
        );
        setWonote([]);
        if (
          noteresp.workOrderNotesList &&
          Array.isArray(noteresp.workOrderNotesList)
        ) {
          noteresp.workOrderNotesList = noteresp.workOrderNotesList.map(
            (o: any) => {
              const bind_addedDate = moment
                .utc(o.addedDate)
                .local()
                .format("MM/DD/YY hh:mm A");
              return {
                ...o,
                bind_addedDate: bind_addedDate,
              };
            }
          );
          setWonote(noteresp.workOrderNotesList);
        }
      }
    }
  };

  const onSubmitNote = async () => {
    console.log("wonotetxt", wonotetxt);
    if (!wonotetxt || wonotetxt.trim() === ``) {
      toast.error(`Please enter a note`);
      return;
    }
    const payload = {
      objRequestModel: [
        {
          workOrderNoteID: null,
          workOrderID: workorder.workOrderID,
          workOrderNote: wonotetxt,
        },
      ],
    };
    setWonotesubmitted(true);
    const noteresp: any = await new Promise((resolve, reject) => {
      workOrderAPI.SaveWorkOrderNotes(
        payload,
        (resp: any) => {
          toast.success(`Note added successfully`);
          setWonotetxt(``);
          resolve(resp);

        },
        (error: any) => {
          toast.error(error);
          reject(error);
        }
      );
    }).catch((err: any) => {
      console.log(`Error in saving note`, err);
    });
    if (noteresp.code == 200 && noteresp.successful === true) {
      const noteresp: any = await get_note_list_api_call().catch((err: any) => {
        console.log(`Error in fetching notes after adding new note`, err);
      });
      if (
        noteresp.workOrderNotesList &&
        Array.isArray(noteresp.workOrderNotesList)
      ) {
        noteresp.workOrderNotesList = noteresp.workOrderNotesList.map(
          (o: any) => {
            const bind_addedDate = moment
              .utc(o.addedDate)
              .local()
              .format("MM/DD/YY hh:mm A");
            return {
              ...o,
              bind_addedDate: bind_addedDate,
            };
          }
        );
        setWonote(noteresp.workOrderNotesList);
      }
    }
    setWonotesubmitted(false);
  };
  const updateAssets = (selectedAssetsn: any) => {
    const payload: any = {
      workOrderID: workorder.workOrderID,
    };
    console.log("selectedAssets22", selectedAssetsn);
    const AssData = selectedAssetsn?.map((item: any) => {
      return {
        assetID: item.assetID,
      };
    });

    const AssData1 = workorder?.workOrderAssetMappingList?.map((item: any) => {
      return {
        assetID: item.assetID,
      };
    });
    const mergedData = [...(Array.isArray(AssData) ? AssData : []), ...(Array.isArray(AssData1) ? AssData1 : [])].filter((value, index, self) =>
      index === self.findIndex((t) => t.assetID === value.assetID)
    );
    console.log("mergedData", mergedData);
    //return;
    payload.woAssetMapping = mergedData;
    showLoader();
    workOrderAPI.SaveWorkOrderAssets(payload, (resp: any) => {
      hideLoader();
      getChecklists(mergedData);
    }, (error: any) => {
      hideLoader();
    });
  };

  const deleteAsset = (assID: any) => {
    // Check if there are parts associated with the work order (using current state from child component)
    if (currentPartsItems.length > 0) {
      toast.error(`Cannot delete asset. Please remove all parts from the Task first.`);
      return;
    }

    if (window.confirm(`Are you sure you want to delete this assets?`)) {
      const payload: any = {
        workOrderID: workorder.workOrderID,
      };

      const AssData = workorder?.workOrderAssetMappingList.filter((item: any) => item.assetID !== assID).map((item: any) => ({
        assetID: item.assetID,
      }));

      //return;
      payload.woAssetMapping = AssData;
      showLoader();
      workOrderAPI.SaveWorkOrderAssets(payload, (resp: any) => {
        hideLoader();
        getChecklists(AssData);
      }, (error: any) => {
        hideLoader();
      });
    }
  };

  const getfacilitylist = () => {
    const payload = {};
    facilityApi.getFacilityList(
      payload,
      (resp: any) => {
        let facilitylist: any = [];
        resp.facilityList.map((facilist: any) => {
          facilitylist.push({
            label: facilist.facilityName,
            value: facilist.facilityID,
            data: facilist,
          });
        });
        setFacilityoption(facilitylist);
      },
      (error: any) => {
        console.log("error =>", error);
        toast.error(error);
      }
    );
  };

  const getChecklists = (selectedAssets: any) => {
    let assetIDs: any = [];
    selectedAssets.map((asset: any, index: number) => {
      assetIDs.push(asset.assetID);
    });
    if (assetIDs && assetIDs.length > 0) {
      let payload: any = {
        assetIDs: assetIDs,
      };
      showLoader();
      checklistAPI.getChecklists(payload, (resp: any) => {
        hideLoader();
        let taskListarray: any = [];
        let payloadChecklist: any = {};
        payloadChecklist.workOrderID = workorder.workOrderID;
        if (resp && resp.hasOwnProperty(`checklistList`) && resp.checklistList && Array.isArray(resp.checklistList)) {
          resp.checklistList.map((checklist: any, index: number) => {
            taskListarray.push(checklist.checkListID);
          });
        }
        payloadChecklist.checkLists = taskListarray;
        showLoader();
        workOrderAPI.SaveWorkOrderTaskDetails(payloadChecklist, (resp: any) => {
          hideLoader();
          //window.location.reload();
          onUpdateRequest();
        }, (error: any) => {
          hideLoader();
          //window.location.reload();
          onUpdateRequest();
        });
      }, (error: any) => {
        hideLoader();
        console.log("error =>", error);
        // toast.error(error);
      });
    } else {
      //window.location.reload();
      onUpdateRequest();
    }
  };

  // Form submission handler
  const onSubmit = (data: any) => {
    // console.log(data);
    // return;

    if (data.submitAction == "savePart") {
      const payload: any = {
        workOrderID: workorder.workOrderID,
      };
      const partsData = data.sparePartsArr?.map((itemSpare: any, index: any) => {
        return {
          woSparePartMappingID: itemSpare.woSparePartMappingID || null,
          sparePartID: itemSpare.partsID,
          assetID: null,
          requiredQty: itemSpare.requiredQty,
          pickedQty: itemSpare.pickedQty,
          facilityID: itemSpare.facilityID?.value,
          subFaclityID: null,
          isPicked: (itemSpare.isPicked == 1) ? true : false,
        };
      });
      payload.woSpareParts = partsData;

      workOrderAPI.SaveWorkOrderInventory(
        payload,
        (resp: any) => {
          window.location.reload();
        },
        (error: any) => {
          window.location.reload();
        }
      );
    } else {
      const payload: any = {
        workOrderID: workorder.workOrderID,
      };
      const partsData = data.sparePartsArr?.map((itemSpare: any, index: any) => {
        return {
          woSparePartMappingID: itemSpare.woSparePartMappingID,
          sparePartID: itemSpare.partsID,
          assetID: null,
          requiredQty: itemSpare.requiredQty,
          pickedQty: itemSpare.pickedQty,
          facilityID: itemSpare.facilityID?.value,
          subFaclityID: null,
          isPicked: true,
        };
      });
      payload.woSpareParts = partsData;

      const payloadpicking1: any[] = data.sparePartsArr
        .filter((part: any) => part.isPicked !== 1)
        .map((part: any, index: any) => ({
          pickNo: Date.now() + index,
          pickingDate: new Date().toISOString(),
          pickedByID: user.userID,
          refWorkorderID: workorder.workOrderID,
          facilityID: part.facilityID?.value || null,
          pickNote: "", // Replace with actual pick note if needed
          subFacilityID: part.subFacilityID?.value || null,
          stockPickDetails: [
            {
              partsID: part.partsID,
              pickQuantity: +part.pickedQty,
              partsCostRate: part.avgUnitCost || 0,
              partsTotalAmount: (part.avgUnitCost || 0) * part.pickedQty,
              unitID: part.unitID || 0,
            },
          ],
        }));

      const payloadpicking: any = {};
      payloadpicking.request = payloadpicking1;
      console.log("data333", payload);
      console.log("sparePartsData", payloadpicking);
      //  return  false;

      const payloadw = { WorkOrderID: workorder.workOrderID };
      workOrderAPI.SaveWorkOrderInventory(
        payload,
        (resp: any) => {
          workOrderAPI.InsertStockPicking(
            payloadpicking,
            (resp: any) => {
              window.location.reload();
            },
            (error: any) => {
              window.location.reload();
            }
          );
        },
        (error: any) => { }
      );
    }
  };

  const handleFacilityChange = (facilityID: any, idx: number) => {
    const payload = { facilityID };
    facilityApi.getSubFacilityList(
      payload,
      (resp: any) => {
        const newSubfacilities = resp?.subFacilityList?.map(
          (subFacility: any) => ({
            label: `${subFacility.subFacilityTypeName} - ${subFacility.no}`,
            value: subFacility.subFacilityID,
          })
        );

        update(idx, {
          ...sparePartsArrFields[idx],

          subFacilityOptions: newSubfacilities,
        });
      },
      (error: any) => {
        console.error("Error fetching subfacilities:", error);

        // Clear subfacilities for that row on error
        update(idx, {
          ...sparePartsArrFields[idx],

          subFacilityOptions: [],
        });
      }
    );
  };

  const validatePickedQty = (value: any, idx: any, ispick: any) => {
    if (ispick === 1) {
      return true;
    }
    const currentStock = sparePartsArrFields[idx]?.currentStock || 0;
    if (parseInt(value) > currentStock) {
      return `Pick Qty cannot be greater than available stock (${currentStock})`;
    }
    return true;
  };
  useEffect(() => {
    // This effect can be used to fetch or update data when the component mounts or params change
    console.log(`workorder general tab ====> `, workorder);
    if (workorder) {
      if (
        workorder?.workOrderAssetMappingList &&
        workorder.workOrderAssetMappingList &&
        Array.isArray(workorder.workOrderAssetMappingList) &&
        workorder.workOrderAssetMappingList.length > 0
      ) {
        console.log("From impacted asset tab -> ", workorder);
        workorder.workOrderAssetMappingList =
          workorder.workOrderAssetMappingList.map((asset: any) => {
            asset[`bind_warrantyEndDate`] = ``;
            if (asset.warrantyEndDate) {
              asset[`bind_warrantyEndDate`] = moment(
                asset.warrantyEndDate
              ).format("MM/DD/YYYY");
            }
            return asset;
          });
        const impactedassetdoropdown = workorder.workOrderAssetMappingList.map(
          (asset: any) => {
            return {
              label: asset.name,
              value: asset.assetID,
            };
          }
        );
        setAssets(impactedassetdoropdown);
      }
      generalDetails();
      getfacilitylist();
    }
    const payload = {
      workOrderID: workorder.workOrderID,
    };
    workOrderAPI.GetWOTasks(
      payload,
      (resp: any) => {
        let uniqueTasks: any = [];
        let seenCheckListIDs = new Set();

        // Filter tasks by checkListID and ensure uniqueness
        resp?.tasks.forEach((task: any) => {
          if (!seenCheckListIDs.has(task.checkListID)) {
            seenCheckListIDs.add(task.checkListID);
            task.title = task.checkListTitle;
            uniqueTasks.push(task);
          }
        });
        setCheckList(uniqueTasks);
      },
      (error: any) => { }
    );
    //setSparePartsData(workorder?.workOrderPartsMappingList);
    remove();
    const getSubFacilityList = (facilityID: any) => {
      return new Promise((resolve, reject) => {
        const payload = { facilityID };
        facilityApi.getSubFacilityList(
          payload,
          (resp: any) => {
            const newSubfacilities: any = resp?.subFacilityList?.map(
              (subFacility: any) => ({
                label: `${subFacility.subFacilityTypeName} - ${subFacility.no}`,
                value: subFacility.subFacilityID,
              })
            );
            resolve(newSubfacilities as any[]);
          },
          (error: any) => {
            console.error("Error fetching subfacilities:", error);
            reject(error);
          }
        );
      });
    }
    const getCurrentStock = (partID: any, facilityID: any, subFacilityID: any) => {
      return new Promise((resolve, reject) => {
        if (subFacilityID && subFacilityID !== null && subFacilityID !== undefined && subFacilityID !== 0) {
          cycleCountAPI.GetStockCount(
            { partID, facilityID, subFacilityID },
            (resp: any) => {
              resolve(resp?.currentStock || 0);
            },
            (error: any) => {
              console.error("Error fetching current stock:", error);
              reject(error);
            }
          );
        } else {
          cycleCountAPI.GetStockCount(
            { partID, facilityID },
            (resp: any) => {
              resolve(resp?.currentStock || 0);
            },
            (error: any) => {
              console.error("Error fetching current stock:", error);
              reject(error);
            }
          );
        }
      });
    }

    workorder?.workOrderPartsMappingList?.forEach((part: any, idx: number) => {
      if (part?.partsID || part?.facilityID) {

        Promise.all([getSubFacilityList(part?.facilityID), getCurrentStock(part?.partsID, part?.facilityID, part?.subFacilityID)]).then(([subFacilityOptions, currentStock]) => {
          append({
            workOrderID: part?.workOrderID,
            partsCode: part.partsCode,
            subFacilityOptions: Array.isArray(subFacilityOptions) ? subFacilityOptions : [],

            partsID: part.partsID,
            pricePerUnit: part.pricePerUnit || 0,
            requiredQty: part.requiredQty || 0,
            sparePartsName: part.sparePartsName,

            facilityID: { value: part.facilityID, label: part.facilityName },
            subFacilityID: { value: part.subFacilityID, label: part.subFacilityNames },
            pickedQty: part.pickedQty || 0,
            assetID: {
              value: part.assetID,
              label: part.assetName,
            },
            assetCode: part,
            isPicked: part.isPicked || false,
            unitID: part.unitID || 0,
            currentStock: currentStock || 0,
            woSparePartMappingID: part.woSparePartMappingID || null,
          });
        }).catch((error) => {
          console.error("Error fetching subfacility or current stock:", error);
          append({
            workOrderID: part?.workOrderID,
            partsCode: part.partsCode,
            subFacilityOptions: [],

            partsID: part.partsID,
            pricePerUnit: part.pricePerUnit || 0,
            requiredQty: part.requiredQty || 0,
            sparePartsName: part.sparePartsName,

            facilityID: { value: part.facilityID, label: part.facilityName },
            subFacilityID: { value: part.subFacilityID, label: part.subFacilityNames },
            pickedQty: part.pickedQty || 0,
            assetID: {
              value: part.assetID,
              label: part.assetName,
            },
            assetCode: part,
            isPicked: part.isPicked || false,
            unitID: part.unitID || 0,
            currentStock: 0,
            woSparePartMappingID: part.woSparePartMappingID || null,
          });
        })
      }



    })

    const allPicked = workorder?.workOrderPartsMappingList?.every((part: any) =>
      part.isPicked === 1
    );
    if (allPicked) {
      setIsPickedTrue(true);
    }

    //console.log(`Workorder details for ID: ${params.id}`, workorder);
  }, []);



  useEffect(() => {
    sparePartsData?.forEach((part, idx) => {
      if (part?.partsID && part?.facilityID) {
        const payload: any = {
          partID: part.partsID,
          facilityID: part.facilityID,
        };
        if (part?.subFacilityID) {
          payload.subFacilityID = part?.subFacilityID;
        }
        handleFacilityChange(part?.facilityID, idx);

        cycleCountAPI.GetStockCount(
          payload,
          (resp: any) => {
            setSparePartsData((prev) =>
              prev.map((p) =>
                p.partsID === part.partsID
                  ? { ...p, currentStock: resp?.currentStock }
                  : p
              )
            );
          },
          (error: any) => console.error(error)
        );
      }
      if (part?.subFacilityID) {
        setValue(`spareParts.${idx}.subfacility`, {
          value: part?.subFacilityID,
          label: part?.subFacilityNames,
        });
      }
    });
  }, [sparePartsData?.length]);
  return (
    <div className="flex">
      <div className="flex-grow border-r border-gray-200 pt-4 overflow-x-auto">
        {!showcustomloader && (
          <div>
            <div className="grid grid-cols-1 gap-6">
              <div>
                {/*
                <div className="flex py-4 border-b border-gray-200 items-center flex-row text-[0.938rem]">
                  <div className="w-[12.5rem] text-[#767676]">
                    <div className="mr-2">Title</div>
                  </div>
                  <div className="w-3/4 text-[#000000]">
                    Plumbing Poultry System <sup style={{color: `#ff0000`}}>Static</sup>
                  </div>
                </div>
                */}
                <div className="py-3 pt-0 border-b border-gray-200 items-center flex flex-row text-[0.938rem]">
                  <div className="w-[9rem] min-w-[9rem] text-[#767676]">
                    <div className="mr-2">Initial Description</div>
                  </div>
                  <div className="w-3/4 text-[#000000]">
                    {workorder?.description || `--`}
                    {((woimages && woimages?.files && Array.isArray(woimages.files) && woimages.files.length > 0) || (wrimages && wrimages?.files && Array.isArray(wrimages.files) && wrimages.files.length > 0)) && (
                      <div className={`flex gap-3 flex-wrap mt-3`}>
                        {woimages && woimages?.files && Array.isArray(woimages.files) && woimages.files.length > 0 && woimages.files.map((file: any) => {
                          return (
                            <a key={file.workOrderFileID} className={`w-[101px] h-[85px] rounded-[5px] overflow-hidden`} href={file.fullFilePath} target="_blank" rel="noopener noreferrer">
                              <img src={file.fullFilePath} alt={file.originalFileName} className={`w-full h-full object-cover object-center`} />
                            </a>
                          );
                        })}
                        {wrimages && wrimages?.files && Array.isArray(wrimages.files) && wrimages.files.length > 0 && wrimages.files.map((file: any) => {
                          return (
                            <a key={file.workOrderFileID} className={`w-[101px] h-[85px] rounded-[5px] overflow-hidden`} href={file.fullFilePath} target="_blank" rel="noopener noreferrer">
                              <img src={file.fullFilePath} alt={file.originalFileName} className={`w-full h-full object-cover object-center`} />
                            </a>
                          );
                        })}
                      </div>
                    )}
                  </div>
                </div>
                <div className="py-3 border-b border-gray-200 items-center flex flex-row text-[0.938rem]">
                  <div className="w-[9rem] min-w-[9rem] text-[#767676]">
                    <div className="mr-2">Note</div>
                  </div>
                  <div className="w-3/4 text-[#000000]">
                    {workorder?.notes || `--`}
                  </div>
                </div>

                <div className="py-3 border-b border-gray-200 items-center flex flex-row text-[0.938rem]">
                  <div className={`grow flex items-center`}>
                    <div className="w-[9rem] min-w-[9rem] text-[#767676]">
                      <div className="mr-2">Planned start</div>
                    </div>
                    <div className="w-[200px] min-w-[200px] text-[#000000]">
                      {workorder.bind_startDate || `--`}
                    </div>
                  </div>
                  <div className={`grow flex items-center ml-10`}>
                    <div className="w-[9rem] min-w-[9rem] text-[#767676]">
                      <div className="mr-2">Actual Start</div>
                    </div>
                    <div className="w-[200px] min-w-[200px] text-[#000000]">
                      {workorder?.bind_originalStartDate || `--`}
                    </div>
                  </div>
                </div>

                <div className="py-3 border-b border-gray-200 items-center flex flex-row text-[0.938rem]">
                  <div className={`grow flex items-center`}>
                    <div className="w-[9rem] min-w-[9rem] text-[#767676]">
                      <div className="mr-2">Planned end</div>
                    </div>
                    <div className="w-[200px] min-w-[200px] text-[#000000]">
                      {workorder.bind_endDate || `--`}
                    </div>
                  </div>
                  <div className={`grow flex items-center ml-10`}>
                    <div className="w-[9rem] min-w-[9rem] text-[#767676]">
                      <div className="mr-2">Actual End</div>
                    </div>
                    <div className="w-[200px] min-w-[200px] text-[#000000]">
                      {workorder?.bind_originalEndDate || `--`}
                    </div>
                  </div>
                </div>
                {/*    
                <div className="py-3 border-b border-gray-200 items-center flex flex-row text-[0.938rem]">
                  <div className={`grow flex items-center`}>
                    <div className="w-[9rem] min-w-[9rem] text-[#767676]">
                      <div className="mr-2">Planned start</div>
                    </div>
                    <div className="w-[200px] min-w-[200px] text-[#000000]">
                      {workorder.bind_startDate || `--`}
                    </div>
                  </div>
                  <div className={`grow flex items-center ml-10`}>
                    <div className="w-[9rem] min-w-[9rem] text-[#767676]">
                      <div className="mr-2">Planned end</div>
                    </div>
                    <div className="w-[200px] min-w-[200px] text-[#000000]">
                      {workorder.bind_endDate || `--`}
                    </div>
                  </div>
                </div>
                {(workorder?.bind_originalStartDate || workorder?.bind_originalEndDate) && (
                  <div className="py-3 border-b border-gray-200 items-center flex flex-row text-[0.938rem]">
                    {workorder?.bind_originalStartDate && (
                      <div className={`grow flex items-center`}>
                        <div className="w-[9rem] min-w-[9rem] text-[#767676]">
                          <div className="mr-2">Original start date</div>
                        </div>
                        <div className="w-[200px] min-w-[200px] text-[#000000]">
                          {workorder?.bind_originalStartDate}
                        </div>
                      </div>
                    )}
                    {workorder?.bind_originalEndDate && (
                      <div className={`grow flex items-center ${workorder?.bind_originalStartDate ? `ml-10` : ``}`}>
                        <div className="w-[9rem] min-w-[9rem] text-[#767676]">
                          <div className="mr-2">Origin end date</div>
                        </div>
                        <div className="w-[200px] min-w-[200px] text-[#000000]">
                          {workorder?.bind_originalEndDate}
                        </div>
                      </div>
                    )}
                  </div>
                )}
                */}
                <div className="py-3 border-b border-gray-200 items-center flex flex-row text-[0.938rem]">
                  <div className="w-[9rem] min-w-[9rem] text-[#767676]">
                    <div className="mr-2">Priority</div>
                  </div>
                  <div className="w-3/4 text-[#000000]">
                    {workorder?.priorityName || `--`}
                  </div>
                </div>
                <div className="py-3 border-b border-gray-200 items-center flex flex-row text-[0.938rem]">
                  <div className={`grow flex items-center`}>
                    <div className="w-[9rem] min-w-[9rem] text-[#767676]">
                      <div className="mr-2">Facility</div>
                    </div>
                    <div className="w-[200px] min-w-[200px] 2xl:w-[420px] 2xl:min-w-[420px] text-[#000000]">
                      {workorder?.facilityName || `--`}
                    </div>
                  </div>
                  <div className={`grow flex items-center ml-10`}>
                    <div className="w-[9rem] m-w-[9rem] text-[#767676]">
                      <div className="mr-2">Sub-Facility</div>
                    </div>
                    <div className="w-[200px] min-w-[200px] 2xl:w-[420px] 2xl:min-w-[420px] text-[#000000]">
                      {workorder?.subFacilityNames || `--`}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="grid grid-cols-1 gap-6 mt-8">
              <div className="pr-4">
                <div className={`flex items-center justify-between mb-3`}>
                  <h4 className="font-semibold text-[0.938rem] py-4">Impacted Asset</h4>
                  {![5, 6, 3].includes(+workorder.woStatusID) && (
                    <button
                      disabled={!getPermissionInfo(location.pathname, "Edit", loggedinuser)}
                      onClick={() => {
                        if (!getPermissionInfo(location.pathname, "Edit", loggedinuser)) {
                          toast.error(`You don't have permission`);
                          return;
                        } else {
                          createAssetModalRef?.current?.showModal();
                        }
                      }}
                      className={`px-4 py-2 rounded text-white ${getPermissionInfo(location.pathname, "Edit", loggedinuser)
                        ? "bg-green-700 hover:bg-green-800"
                        : "bg-[#a3bfa3] cursor-not-allowed"}`}
                    >
                      Add Asset
                    </button>
                  )}
                </div>
                <CreateAssetsModal _ref={createAssetModalRef} facility={{ label: workorder?.facilityName, value: workorder?.facilityID }} onContinue={(selectedAssets: any[]) => {
                  console.log("Selected Assets", selectedAssets);
                  //setValue("assets", selectedAssets);
                  setSelectedAssets(selectedAssets);
                  //setRowData(selectedAssets);
                  updateAssets(selectedAssets);
                  createAssetModalRef?.current?.close();
                }} />

                <div className={`border border-[#043E6133] rounded-[5px] w-full overflow-x-auto  parts-table`}>
                  <div className={`flex items-center flex-nowrap bg-[#F0F0F0] rounded-ss-[5px] rounded-se-[5px]`}>
                    <div className={`w-40 min-w-40 max-w-40 font-semibold text-[#262A2D] bg-[#F0F0F0] text-[14px] px-2.5 py-2 h-[50px] flex items-center`}>Asset ID</div> {/* 176px */}
                    <div style={{ width: ([1, 2, 7, 4].includes(+workorder.woStatusID) ? `calc(100% - 720px)` : `calc(100% - 672px)`) }} className={`font-semibold text-[#262A2D] bg-[#F0F0F0] text-[14px] px-2.5 py-2 h-[50px] flex items-center`}>Asset Name</div> {/* 270px */}
                    <div className={`w-40 min-w-40 max-w-40 font-semibold text-[#262A2D] bg-[#F0F0F0] text-[14px] px-2.5 py-2 h-[50px] grow flex items-center justify-center`}>Status</div> {/* 112px */}
                    <div className={`w-48 min-w-48 max-w-48 font-semibold text-[#262A2D] bg-[#F0F0F0] text-[14px] px-2.5 py-2 h-[50px] grow flex items-center justify-center`}>Last Maintenance Date</div> {/* 112px */}
                    <div className={`w-48 min-w-48 max-w-48 font-semibold text-[#262A2D] bg-[#F0F0F0] text-[14px] px-2.5 py-2 h-[50px] grow flex items-center justify-center`}>Warranty Expiry Date</div> {/* 112px */}
                    {[1, 2, 7, 4].includes(+workorder.woStatusID) && (
                      <div className={`w-12 min-w-12 max-w-12 font-semibold text-[#262A2D] bg-[#F0F0F0] text-[14px] px-2.5 py-2 h-[50px] grow flex items-center justify-center`}></div>
                    )}
                  </div>
                  <div>
                    {assetList.length === 0 && (
                      <div className={`flex items-center justify-center h-24 text-gray-500`}>
                        No asset added yet.
                      </div>
                    )}
                    {assetList.map((asset: any, index: number) => (
                      <div className={`flex items-center flex-nowrap`} key={`asset-item-${index}`}>
                        <div className={`w-40 min-w-40 max-w-40 font-normal text-[#42484B] text-[15px] px-2 min-h-12 max-h-12 flex items-center bg-[#F9F9F9] ${index < (assetList.length - 1) ? `border-b border-[#043E6133]` : ``}`}>
                          {asset.assetCode}
                        </div>
                        <div style={{ width: ([1, 2, 7, 4].includes(+workorder.woStatusID) ? `calc(100% - 720px)` : `calc(100% - 672px)`) }} className={`font-normal text-[#42484B] text-[15px] px-2.5 min-h-12 max-h-12 bg-[#F9F9F9] flex items-center ${index < (assetList.length - 1) ? `border-b border-[#043E6133]` : ``}`}>
                          <div className={`line-clamp-1`}>{asset.name}</div>
                        </div>
                        <div className={`w-40 min-w-40 max-w-40 font-normal text-[#42484B] text-[15px] px-2.5 min-h-12 max-h-12 flex items-center justify-center bg-[#F9F9F9]  ${index < (assetList.length - 1) ? `border-b border-[#043E6133]` : ``} ${[5, 6, 3].includes(+workorder.woStatusID) ? `pointer-events-none` : ``}`}>
                          <div className={`grow`}>
                            <AssetStatus
                              asset={asset}
                              onUpdate={onUpdateRequest}
                              canChange={getPermissionInfo(location.pathname, "Change Asset Status", loggedinuser)}
                            />
                          </div>
                        </div>
                        <div className={`w-48 min-w-48 max-w-48 font-normal text-[#42484B] text-[15px] px-2.5 min-h-12 max-h-12 bg-[#F9F9F9] flex items-center justify-center ${index < (assetList.length - 1) ? `border-b border-[#043E6133]` : ``}`}>
                          {asset?.lastMaintenance || `--`}
                        </div>
                        <div className={`w-48 min-w-48 max-w-48 font-normal text-[#42484B] text-[15px] px-2.5 min-h-12 max-h-12 bg-[#F9F9F9] flex items-center justify-center ${index < (assetList.length - 1) ? `border-b border-[#043E6133]` : ``}`}>
                          {asset.bind_warrantyEndDate || `--`}
                        </div>
                        {[1, 2, 7, 4].includes(+workorder.woStatusID) && (
                          <div className={`w-12 min-w-12 max-w-12 font-normal text-[#42484B] bg-white text-[15px] px-2.5 py-3 min-h-12 max-h-12 ${index < (assetList.length - 1) ? `border-b border-[#043E6133]` : ``}`}>
                            <div className={`flex items-center justify-center`}>
                              {(workorder.woStatusID == 1 || workorder.woStatusID == 2 || workorder.woStatusID == 7 || workorder.woStatusID == 4) && (
                                <button type="button" className="text-pink-500 hover:text-pink-700 flex items-center justify-center" onClick={() => {
                                  deleteAsset(asset?.assetID);
                                }}>
                                  <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect y="0.5" width="15.0008" height="15" rx="7.5" fill="#E6BDCB" />
                                    <path d="M10.8974 10.9022C10.93 10.9347 10.9557 10.9733 10.9733 11.0158C10.9909 11.0583 11 11.1038 11 11.1498C11 11.1958 10.9909 11.2413 10.9733 11.2838C10.9557 11.3263 10.93 11.3649 10.8974 11.3974C10.8649 11.43 10.8263 11.4557 10.7838 11.4733C10.7413 11.4909 10.6958 11.5 10.6498 11.5C10.6038 11.5 10.5583 11.4909 10.5158 11.4733C10.4733 11.4557 10.4347 11.43 10.4022 11.3974L7.5 8.49478L4.59779 11.3974C4.53212 11.4631 4.44305 11.5 4.35018 11.5C4.2573 11.5 4.16823 11.4631 4.10256 11.3974C4.03689 11.3318 4 11.2427 4 11.1498C4 11.057 4.03689 10.9679 4.10256 10.9022L7.00521 8L4.10256 5.09779C4.03689 5.03212 4 4.94305 4 4.85018C4 4.7573 4.03689 4.66823 4.10256 4.60256C4.16823 4.53689 4.2573 4.5 4.35018 4.5C4.44305 4.5 4.53212 4.53689 4.59779 4.60256L7.5 7.50521L10.4022 4.60256C10.4679 4.53689 10.557 4.5 10.6498 4.5C10.7427 4.5 10.8318 4.53689 10.8974 4.60256C10.9631 4.66823 11 4.7573 11 4.85018C11 4.94305 10.9631 5.03212 10.8974 5.09779L7.99478 8L10.8974 10.9022Z" fill="#F31260" />
                                  </svg>
                                </button>
                              )}
                            </div>
                          </div>
                        )}
                      </div>
                    ))}

                  </div>
                </div>

              </div>
            </div>

            <PartlistWOdetails disabled={assetList.length === 0} workorder={workorder} onUpdate={onUpdateRequest} onPartsChange={setCurrentPartsItems} />

            <div className="grid grid-cols-1 gap-6 mt-0">
              <div className="p-6 space-y-2" style={{ paddingLeft: `0px` }}>
                {wonote && Array.isArray(wonote) && wonote.length > 0 && ![5, 6, 3].includes(+workorder.woStatusID) && (<h1 className="text-lg font-normal">Notes</h1>)}

                {![5, 6, 3].includes(+workorder.woStatusID) && (
                  <>
                    <textarea value={wonotetxt || ``} placeholder="Write Your Notes" className="w-full p-3 border border-gray-300 rounded resize-none h-24" style={{ outline: `none` }} onChange={(e) => {
                      setWonotetxt(e.target.value);
                    }}
                    />

                    <div className="flex gap-3 justify-end" style={{ marginTop: `12px` }}>
                      {wonotesubmitted ? (
                        <Loader />
                      ) : (
                        <>
                          <button
                            disabled={
                              (!wonotetxt || wonotetxt.trim() === `` || wonotesubmitted) ||
                              !getPermissionInfo(location.pathname, "Edit", loggedinuser)
                            }
                            onClick={() => {
                              if (!getPermissionInfo(location.pathname, "Edit", loggedinuser)) {
                                toast.error(`You don't have permission`);
                                return;
                              } else {
                                onSubmitNote();
                              }
                            }}
                            className={`px-4 py-2 rounded text-[0.813rem] text-white ${(!wonotetxt || wonotetxt.trim() === `` || wonotesubmitted) ||
                              !getPermissionInfo(location.pathname, "Edit", loggedinuser)
                              ? "bg-[#a3bfa3] cursor-not-allowed"
                              : "bg-green-700 hover:bg-green-800"}`}
                            style={{ width: `111px` }}
                          >
                            Add
                          </button>
                          <button
                            disabled={wonotesubmitted || !getPermissionInfo(location.pathname, "Edit", loggedinuser)}
                            onClick={() => {
                              if (!getPermissionInfo(location.pathname, "Edit", loggedinuser)) {
                                toast.error(`You don't have permission`);
                                return;
                              } else {
                                setWonotetxt(``);
                                setWonotesubmitted(false);
                              }
                            }}
                            className={`px-4 py-2 rounded text-[0.813rem] text-white ${wonotesubmitted || !getPermissionInfo(location.pathname, "Edit", loggedinuser)
                              ? "bg-[#cbb8b3] cursor-not-allowed"
                              : "bg-[#8D6E63] hover:bg-[#6d5047]"}`}
                            style={{ width: `111px` }}
                          >
                            Clear
                          </button>
                        </>
                      )}
                    </div>
                  </>
                )}

                {wonote && Array.isArray(wonote) && wonote.length > 0 && (
                  <div style={{ marginTop: `30px`, border: `1px solid #dfdfdf`, borderRadius: `5px` }} className="p-3" >
                    {wonote.map((note: any, index: number) => (
                      <div key={index} style={{ marginBottom: `14px` }}>
                        <p className="bg-[#f0f0f0] p-4 text-[#000000] tex-[0.813rem]" style={{ border: `1px solid #dfdfdf`, borderRadius: `10px` }}>
                          {note.workOrderNote}
                        </p>
                        <div className="flex items-center justify-between text-sm text-dark-100 mt-2" style={{ paddingRight: `3px` }}>
                          <a href="javascript:void(0);" style={{ color: `#ff0000` }} className="flex items-center gap-1" onClick={() => {
                            if (!getPermissionInfo(location.pathname, "Edit", loggedinuser)) {
                              toast.error(`You don't have permission to delete note`);
                              return;
                            } else {
                              deleteWONote(note.workOrderNoteID);
                            }
                          }}>
                            <Icon name="delete" size={0.75} />
                            Delete
                          </a>
                          <div className={`text-right`}>
                            By: {note.addedByName}{" "} {moment(note.bind_addedDate).format(`MM/DD/YY - h:mm A`)}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>

          </div>
        )}
        {showcustomloader && (
          <div style={{ padding: `15px` }}>
            <Loader />
          </div>
        )}
      </div>

      <div
        className="p-[1.125rem] flex-grow-0 flex-shrink-0"
        style={{ width: `312px` }}
      >
        {/* w-[19.5rem] */}
        <SidebarWOdetails workorder={workorder} />
      </div>
    </div>
  );
};

export default GeneralWOdetails;
